module.exports = __webpack_public_path__ + "img/icon_hashtag@3x.e7b31b9.png";